'use client'

import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useStoreNavigate } from '@/hooks/use-app-navigate'

export const ShippingDetailsNotFound = () => {
	const { t } = useTranslation('shippings')
	const { storeRoutes, navigate } = useStoreNavigate()

	return (
		<div className="bg-background flex min-h-screen items-center justify-center">
			<div className="flex flex-col items-center gap-4 text-center">
				<h2 className="text-2xl font-semibold">{t('notFound')}</h2>
				<p className="text-muted-foreground">{t('notFoundDescription')}</p>
				<Button onClick={() => navigate(storeRoutes.SHIPPINGS())}>{t('backToShippingRates')}</Button>
			</div>
		</div>
	)
}

